import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  Radio,
  makeStyles,
} from '@material-ui/core'
import clsx from 'clsx'
import { useField } from 'formik'
import React from 'react'
import equal from 'fast-deep-equal'

import { Typography } from 'src/modules/ui'

const useStyles = makeStyles(theme => ({
  tableRow: {
    display: 'table-row',
  },
  label: {
    paddingRight: theme.spacing(4),
  },
  labelCell: {
    verticalAlign: 'middle',
  },
}))

export const FormikRadioGroup = ({ name, ...props }) => {
  const [, fieldGroupMeta] = useField({ name, type: 'radio' })
  const { touched, error } = fieldGroupMeta
  const hasError = Boolean(touched && error)

  return (
    <MemoFormikRadioGroup
      error={error}
      hasError={hasError}
      name={name}
      {...props}
    />
  )
}

const MemoFormikRadioGroup = React.memo(
  ({ error, fullWidth, hasError, margin, name, options, label, table }) => {
    const classes = useStyles()
    const rowComponent = table ? 'tr' : undefined
    const cellComponent = table ? 'td' : undefined

    return (
      <>
        <FormControl
          className={clsx({
            [classes.tableRow]: table,
          })}
          component={rowComponent}
          fullWidth={fullWidth}
          margin={margin}
        >
          {label ? (
            <Typography
              component={cellComponent}
              className={clsx(classes.label, {
                [classes.labelCell]: table,
              })}
            >
              {label}
            </Typography>
          ) : null}
          {options.map((option, idx) => (
            <FormikRadio
              component={cellComponent}
              name={name}
              {...option}
              key={idx}
            />
          ))}
        </FormControl>
        {hasError && <FormHelperText error>{error}</FormHelperText>}
      </>
    )
  },
  equal
)

const FormikRadio = ({ component, label, name, value }) => {
  const [field] = useField({
    type: 'radio',
    name,
    value,
  })
  return <MemoRadio component={component} field={field} label={label} />
}

const MemoRadio = React.memo(({ component, field, label }) => {
  const Component = component || React.Fragment
  return (
    <Component>
      <FormControlLabel
        component={component}
        control={<Radio {...field} />}
        label={label}
      />
    </Component>
  )
}, equal)

export default FormikRadioGroup
